// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SchemaFunctionListQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  offset?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  limit?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  filter?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  sortBy?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  sortDirection?: Types.InputMaybe<Types.SortDirection>;
}>;

export type SchemaFunctionListQuery = {
  __typename?: "GraphqlQuery";
  getSchemaFunctions: Array<{
    __typename?: "SchemaFunction";
    id: string;
    schemaName: string;
    functionName: string;
    language: string;
    securityDefiner: boolean;
    issues?: Array<{
      __typename?: "Issue";
      id: string;
      state: string;
      description: string;
      severity: string;
      references: Array<{ __typename?: "IssueReference"; name: string }>;
    } | null> | null;
  }>;
};

export const SchemaFunctionListDocument = gql`
  query SchemaFunctionList(
    $databaseId: ID!
    $offset: Int
    $limit: Int
    $filter: String
    $sortBy: String
    $sortDirection: SortDirection
  ) {
    getSchemaFunctions(
      databaseId: $databaseId
      offset: $offset
      limit: $limit
      filter: $filter
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      id
      schemaName
      functionName
      language
      securityDefiner
      issues {
        id
        state
        description
        severity
        references {
          name
        }
      }
    }
  }
`;

/**
 * __useSchemaFunctionListQuery__
 *
 * To run a query within a React component, call `useSchemaFunctionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaFunctionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaFunctionListQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useSchemaFunctionListQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemaFunctionListQuery,
    SchemaFunctionListQueryVariables
  > &
    (
      | { variables: SchemaFunctionListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SchemaFunctionListQuery,
    SchemaFunctionListQueryVariables
  >(SchemaFunctionListDocument, options);
}
export function useSchemaFunctionListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemaFunctionListQuery,
    SchemaFunctionListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SchemaFunctionListQuery,
    SchemaFunctionListQueryVariables
  >(SchemaFunctionListDocument, options);
}
// @ts-ignore
export function useSchemaFunctionListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemaFunctionListQuery,
    SchemaFunctionListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemaFunctionListQuery,
  SchemaFunctionListQueryVariables
>;
export function useSchemaFunctionListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaFunctionListQuery,
        SchemaFunctionListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemaFunctionListQuery | undefined,
  SchemaFunctionListQueryVariables
>;
export function useSchemaFunctionListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaFunctionListQuery,
        SchemaFunctionListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SchemaFunctionListQuery,
    SchemaFunctionListQueryVariables
  >(SchemaFunctionListDocument, options);
}
export type SchemaFunctionListQueryHookResult = ReturnType<
  typeof useSchemaFunctionListQuery
>;
export type SchemaFunctionListLazyQueryHookResult = ReturnType<
  typeof useSchemaFunctionListLazyQuery
>;
export type SchemaFunctionListSuspenseQueryHookResult = ReturnType<
  typeof useSchemaFunctionListSuspenseQuery
>;
export type SchemaFunctionListQueryResult = Apollo.QueryResult<
  SchemaFunctionListQuery,
  SchemaFunctionListQueryVariables
>;
